import React from "react";
import styles from "./FichaTecnica.module.scss";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";
import HouseIcon from "@mui/icons-material/House";
import logo from "../assets/logoCropped.png";
import { useLocation } from "react-router-dom";
import { useGetDocumentByDocumentId } from "../Hooks/FetchHook";

export const FichaTecnica: React.FC = () => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const propertyId = queryParams.get("propertyId");

  const { data: property, isLoading: isLoadingProperty } =
    useGetDocumentByDocumentId("propiedad", propertyId ?? "");

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  });

  if (isLoadingProperty || !property) return <div>Loading...</div>;
  else
    return (
      <>
        <div className={styles.fichaTecnicaContainer}>
          <div className={styles.topSection}>
            <img src={logo} alt="logo" />
            <div className={styles.topContent}>
              <h1 className={styles.title}>{property.titulo}</h1>
              <h2 className={styles.subtitle}>{property.direccion}</h2>
            </div>
          </div>

          <div className={styles.content}>
            <div className={styles.leftSection}>
              <div className={styles.rentPrice}>
                <h3>
                  Precio de {property.tipoDeNegocio.toLowerCase()}:{" "}
                  <h3 className={`${styles.rentPriceDigits}`}>
                    {formatter.format(property.precio)}
                  </h3>
                </h3>
              </div>

              <div className={styles.propertyDetails}>
                <p>
                  <strong>Tipo de propiedad:</strong> {property.tipoDePropiedad}
                </p>
                <p>
                  <strong>Descripción Detallada:</strong>
                </p>
                <ul>
                  {property.descripcion
                    .split("*")
                    .filter(
                      (description: any, idx: number) =>
                        idx !== 0 &&
                        idx !== property.descripcion.split("*").length - 1
                    )
                    .map((paragraph: string, idx: number) => (
                      <li
                        key={idx}
                        className={`${
                          paragraph === paragraph.toUpperCase()
                            ? styles.paragraphSection
                            : ""
                        }`}
                      >
                        {paragraph}
                      </li>
                    ))}
                </ul>
              </div>

              <div className={styles.imagesLeftSection}>
                <img src={property.imagenesURLs[0]} alt="" />
                <img src={property.imagenesURLs[1]} alt="" />
              </div>
            </div>

            <div className={styles.rightSection}>
              <div className={styles.imagesRightSection}>
                <img src={property.imagenesURLs[2]} alt="" />
                <img src={property.imagenesURLs[3]} alt="" />
              </div>

              <div className={styles.additionalInfo}>
                <p>Área total del terreno:</p>
                <p className={styles.meters}>{property.terreno} m²</p>

                <p>Área construida:</p>
                <p className={styles.meters}>{property.construccion} m²</p>
              </div>

              <div className={styles.contactInfo}>
                <p className={styles.name}>MARTHA SOSA</p>
                <p className={styles.asesorlbl}>ASESOR CERTIFICADO</p>

                <div className={styles.contactDataSection}>
                  <p className={styles.contactData}>
                    <WhatsAppIcon className={styles.contactDataIcon} /> 999 647
                    79 98
                  </p>

                  <p className={styles.contactData}>
                    <EmailIcon className={styles.contactDataIcon} />
                    msbienesraices08@gmail.com
                  </p>

                  <p className={styles.contactData}>
                    <HouseIcon className={styles.contactDataIcon} /> Cancún,
                    Quintana Roo
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
};
